var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('module-navigator',{staticClass:"mb-3",attrs:{"nav-opts":_vm.navOpts}})}
var staticRenderFns = []

export { render, staticRenderFns }